import { render, staticRenderFns } from "./Renglones.vue?vue&type=template&id=4ccb612c&"
import script from "./Renglones.vue?vue&type=script&lang=js&"
export * from "./Renglones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports